import { floatlabels } from 'tools/floatlabels_custom';
import { addStyleClassForIeBrowser } from 'tools/addStyleClassForIeBrowser';

floatlabels('.floatlabel_1');

addStyleClassForIeBrowser();
